import TabPage from "./../../factories/tab-page";
import "./../../services/bao-menu";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/element";
import * as ko from "knockout";
import "./../../bindings/bao-number-box";
import Bao from "./../../services/bao-service";
import BaseViewModel from "./../../factories/base-view-model2";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ShiftPlanModel from "../shift-plan-model";

class ShiftPlanModelPreviewTab extends BaseViewModel {
    Bao = Bao;
    Parent: ShiftPlanModel;

    Groups: KnockoutObservableArray<any> = ko.observableArray([]);
    Calendar: KnockoutObservable<any> = ko.observable([]);
    ShiftPlans: KnockoutObservableArray<any[]> = ko.observableArray([]);
    PermissionShowWeakShiftdays: KnockoutObservable<boolean> = ko.observable(false);
    ShiftPlanModelId: KnockoutObservable<string> = ko.observable(null);
    ToolbarName: string = null;
    ToolbarButtons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
    ApplicationId = '1A38B671-948C-42EE-B80D-F6B9A12814B6';
    RefreshNeeded: boolean = false;
    ShowPreview: KnockoutObservable<boolean> = ko.observable(false);

    // required by base class
    InitUrl() {
        return "";
    }
    CompleteCheck() {
        return true;
    }

    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.Parent = parent;
    }

    registerEvents() {
   
    }

    init() {
        this.Parent.TabPage.DirtyFlag.subscribe((isDirty) => {
            if (isDirty) {
                this.RefreshNeeded = true;
            }
        });

        this.TabPage.IsActiveTab.subscribe((newval) => {
            if (this.RefreshNeeded === true) {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftPlanModelOutdate"), "info");
                this.RefreshNeeded = false;
            }
        });
        Bao.bindEvent('shiftplanmodelshiftgroup:refresh', (params) => {
            if (this.Groups().find(x => x.ShiftGroupId === params.id)) {
                if (!this.Parent.TabPage.IsActiveTab()) {
                    this.Refresh();
                }
            }
        });

        this.TabPage.IsLoading(true);
        return super.init().then(_ => {
                return Bao.post('ShiftPlanModelPreviewTab/Init', JSON.stringify({ id: this.TabPage.UrlData().id }), (model) => {
                    ko.map.fromJS(model.Definition, this);
                    this.TabPage.Title(model.TabTitle);
                });
            })
            .then(_ => this.Refresh());
    }

    loaded() {
        super.loaded();
        this.TabPage.IsLoading(false);
    }

    CustomToolbarClick(button) {
    }

    ToolbarClick = (button: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case 'ShiftPlanModelPreviewTabRefresh':
                this.TabPage.IsLoading(true);
                this.Refresh()
                    .always(_ => this.TabPage.IsLoading(false));
                break;
            default:
                this.CustomToolbarClick(button);
                break;
        }
    };

    BindingToolbar: Bindings.baoToolbar2 = {
        buttons: this.ToolbarButtons,
        click: this.ToolbarClick,
        toolbarName: null,
        formName: 'ShiftPlanModelPreviewTab',
        applicationId: this.ApplicationId
    };

    Refresh(): JQueryPromise<void> {
        return Bao.post('ShiftPlanModelPreviewTab/LoadData', JSON.stringify({
            shiftPlanModelId: this.Parent.ShiftPlanModelId(),
            sessionTabId: this.Parent.SessionTabId()
        }))
            .then((result) => {
                this.RefreshNeeded = false;
                this.Groups(result.Groups);
                this.Calendar(result.Calendar);
                this.ShiftPlans(result.ShiftPlans);
                if (this.Groups().length === 0 || this.ShiftPlans().length === 0) {
                    this.ShowPreview(false);
                }
                else {
                    this.ShowPreview(true);
                }
            });
    }
}
export default ShiftPlanModelPreviewTab;
